import { disableNetwork, enableNetwork } from 'firebase/firestore';
import { firestore } from '../firebaseConfig';

/**
 * Forces a full Firestore reconnect by explicitly disabling then re-enabling
 * the network. This is the only safe way to trigger a reconnect — calling
 * enableNetwork() alone on an already-active connection resets the watch
 * stream state machine without tearing down the underlying WebSocket, causing
 * in-flight messages to arrive at an unexpected state (Firebase SDK bug
 * #7884, #8189, #8250).
 *
 * Only use this when the OS may have actually suspended the connection
 * (e.g. PWA returning from background on mobile). Do NOT call this on
 * visibilitychange in a desktop browser — the SDK handles reconnection
 * automatically via its own NetworkConnectivityMonitor.
 */
export const reconnectFirestore = async () => {
  try {
    await disableNetwork(firestore);
    await enableNetwork(firestore);
  } catch (e) {
    // Fails silently if Firestore is not yet initialized — safe to ignore
  }
};
